import {
  IListItemDetails,
  IListRow,
  ListItem,
  ListSelection,
  ScrollableList,
} from 'azure-devops-ui/List';
import React, { useState } from 'react';
import PersonaRow from './PersonaRow';
import { Header, TitleSize } from 'azure-devops-ui/Header';
import { IHeaderCommandBarItem } from 'azure-devops-ui/HeaderCommandBar';
import PersonaEditor from './PersonaEditor';
import { clone } from 'lodash';
import { useProjectContextProviderContext } from '../../../hooks/useProjectContextProviderContext';
import { ObservableArray } from 'azure-devops-ui/Core/Observable';
import { Persona, ProjectContext } from '../../../clients/ogg';
import { ZeroData, ZeroDataActionType } from 'azure-devops-ui/ZeroData';

export interface IPersonasProps {
  personas: Persona[];
  projectContext: ProjectContext;
  onPersonasUpdated?: (personas: Persona[]) => void;
}

export default function Personas(props: IPersonasProps) {
  const selection = new ListSelection(true);
  const [personas, setPersonas] = useState(new ObservableArray<Persona>(props.personas ?? []));
  const [selectedPersona, setSelectedPersona] = useState(null as IListRow<Persona>);
  const projectContextProvider = useProjectContextProviderContext();

  console.log('loading personas', personas, props.personas);

  const personasButtons: IHeaderCommandBarItem[] = [
    {
      iconProps: {
        iconName: 'PeopleAdd',
      },
      id: 'addPersona',
      important: true,
      isPrimary: true,
      onActivate: () => {
        addPersona();
      },
      tooltipProps: { text: 'Add a Persona' },
    },
  ];

  function renderRow(
    index: number,
    item: Persona,
    details: IListItemDetails<Persona>,
    key?: string
  ): JSX.Element {
    return (
      <ListItem key={key || 'list-item' + index} index={index} details={details}>
        <PersonaRow name={item.name} description={item.description} />
      </ListItem>
    );
  }

  function addPersona() {
    setSelectedPersona({
      data: {},
      index: personas.length,
    });
  }

  function updatePersonasSource() {
    props.projectContext.eligiblePersonas = personas.value;
    projectContextProvider.setProjectContext(props.projectContext);
    if (!!props.onPersonasUpdated) props.onPersonasUpdated(personas.value);
    setSelectedPersona(null);
    setPersonas(personas);
  }

  function updatePersona(persona: Persona) {
    if (selectedPersona.index >= personas.length) personas.push(persona);
    else personas.change(selectedPersona.index, persona);

    updatePersonasSource();
  }

  function deletePersona() {
    personas.splice(selectedPersona.index, 1);

    updatePersonasSource();
  }

  return (
    <div className='editable-list' style={{ width: '100%' }}>
      <Header
        title={'Personas'}
        description='Provide a list of personas so that Ogg Extensions may advise your team accordingly.'
        commandBarItems={personasButtons}
        titleSize={TitleSize.Small}
        titleIconProps={{ iconName: 'People' }}
        titleAriaLevel={3}
      />
      <div
        style={{ display: 'flex', minHeight: '300px', maxWidth: '100%' }}
        className='editable-list-content'
      >
        {personas.length == 0 ? (
          <div className='flex-column flex-center full-width'>
            <ZeroData
              primaryText='Looks empty in here'
              imageAltText='No personas'
              iconProps={{
                iconName: 'Group',
              }}
              actionText='Add a new Persona'
              actionType={ZeroDataActionType.ctaButton}
              onActionClick={addPersona}
            />
          </div>
        ) : (
          <ScrollableList
            itemProvider={personas}
            renderRow={renderRow}
            selection={selection}
            maxWidth='100%'
            width='100%'
            onSelect={(event, row) => {
              setSelectedPersona(row);
            }}
          />
        )}
      </div>
      {selectedPersona != null && (
        <PersonaEditor
          persona={clone(selectedPersona.data)}
          onCancel={() => setSelectedPersona(null)}
          onPersonaChanged={updatePersona}
          onDelete={deletePersona}
        />
      )}
    </div>
  );
}
